import { render, staticRenderFns } from "./TopicoImagem.vue?vue&type=template&id=4e71156c&scoped=true"
import script from "./TopicoImagem.vue?vue&type=script&lang=js"
export * from "./TopicoImagem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e71156c",
  null
  
)

export default component.exports